var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteFeather = function SvgQuoteFeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.717773,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F7F5FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.24 28.9578C37.3658 27.832 37.9983 26.305 37.9983 24.7128C37.9983 23.1206 37.3658 21.5937 36.24 20.4678C35.1142 19.342 33.5872 18.7095 31.995 18.7095C30.4028 18.7095 28.8758 19.342 27.75 20.4678L21 27.2178V35.7178H29.5L36.24 28.9578Z",
    stroke: "#8055C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.7178L18 38.7178",
    stroke: "#8055C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 31.7178H25",
    stroke: "#8055C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgQuoteFeather;